import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/logo.png";
import bgvideo from "../../images/bgvideo.mp4";
import facebook from "../../images/facebook.svg";
import google from "../../images/google.svg";
import twitterfill from "../../images/twitter-fill.svg";
import { Link } from "react-router-dom";
import { callApi } from "../common/API/Api";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import LanguageSwitcher from "../common/LanguageSwitcher";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { getBaseUrl } from "../common/BaseUrl";
const Signup = () => {
  document.title = "Equlix";
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [captchaValue, setCaptchaValue] = useState(null);
  const lid = localStorage.getItem("lid");
  const [opencol, setOpencol] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordMissing, setPasswordMissing] = useState(null)
  const { executeRecaptcha } = useGoogleReCaptcha();
  let base_url = getBaseUrl();
  let base_api_url = process.env.REACT_APP_API_URL;

  const twitterlogin = async () => {
    try {
      let url = `${base_api_url}auth/twitter`;
      window.location.href = url;
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "9178007688902901",
        cookie: true,
        xfbml: true,
        version: "v18.0",
      });
    };

    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const handleFacebookLogin = () => {
    if (!window.FB) {
      console.error("Facebook SDK not loaded yet.");
      return;
    }

    window.FB.login(
      function (response) {
        if (response.authResponse) {
          console.log(response, "Welcome! Fetching your information....");
          fetchFacebookData(response.authResponse.accessToken);
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "public_profile,email" },
    );
  };

  const fetchFacebookData = async (accessToken) => {
    try {
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/auth/facebook/callback?token=${accessToken}`,
        "GET",
      );
      if (res?.data?.success) {
        localStorage.setItem("token", res?.data?.token);
        navigate(`${base_url}userdashboard`, {
          state: { from: "real_account" },
        });
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message || t("Login failed"),
        }));
        localStorage.setItem("token", "");
      }
    } catch (err) {
      console.log(err, "Error during API call");
    }
  };
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };
  const googleLoginRef = useRef(null);
  const handleLoginSuccess = async (response) => {
    try {
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/auth/google/callback?token=${response?.credential}`,
        "GET",
      );
      if (res?.data?.success) {
        localStorage.setItem("token", res?.data?.token);
        navigate(`${base_url}userdashboard`, {
          state: { from: "real_account" },
        });
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message || t("Login failed"),
        }));
        localStorage.setItem("token", "");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const handleLoginFailure = (error) => {
    console.log("Login Failed:", error);
  };

  const handleImageClick = () => {
    googleLoginRef.current?.signIn();
  };
  const [signupdata, setSignupdata] = useState({ name: "User" });
  const [loading, setLoading] = useState(false);
  const [showpassword, setShowpassword] = useState({
    password: false,
    confirmpassword: false,
  });
  const [validmessage, setvalidmessage] = useState({
    name: "",
    email: "",
    password: "",
    confirmpassword: "",
    matchpassword: "",
    error: "",
    success: "",
    robot: "",
  });
  const allsignupdata = (key, value) => {
    setSignupdata((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const signupvalidction = (signupdata) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!signupdata?.name) {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     name: t("Name is Required"),
    //     error: "",
    //     success: "",
    //   }));
    //   return;
    // } else {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     name: "",
    //   }));
    // }
    if (!signupdata?.email) {
      setvalidmessage((state) => ({
        ...state,
        email: t("Email is Required"),
        error: "",
        success: "",
      }));
      return;
    } else if (!emailRegex.test(signupdata?.email)) {
      setvalidmessage((state) => ({
        ...state,
        email: t("Please enter a valid email address."),
        error: "",
        success: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        email: "",
      }));
    }
    if (!signupdata?.password) {
      setvalidmessage((state) => ({
        ...state,
        password: t("password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        password: "",
      }));
      if (passwordStrength === "Weak") {
        return;
      } else if (passwordStrength === "Medium") {
        return;
      }
    }
    // if (!signupdata?.confirmpassword) {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     confirmpassword: t("Confirmpassword is Required"),
    //     error: "",
    //     success: "",
    //   }));
    //   return;
    // } else {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     confirmpassword: "",
    //   }));
    // }
    // if (signupdata?.password !== signupdata?.confirmpassword) {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     matchpassword: t("Passwords do not match."),
    //     error: "",
    //     success: "",
    //   }));
    //   return;
    // } else {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     matchpassword: "",
    //   }));
    // }
    if (!signupdata?.notus) {
      setvalidmessage((state) => ({
        ...state,
        notus: "Please confirm this declaration to proceed.",
        error: "",
        success: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        notus: "",
      }));
    }

    // if (!executeRecaptcha) {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     robot: "Please verify that you are not a robot",
    //     error: "",
    //     success: "",
    //   }));

    //   return;
    // } else {
    //   setvalidmessage((state) => ({
    //     ...state,
    //     robot: "",
    //   }));
    // }
    signup(signupdata);
  };
  const signup = async (signupdata) => {
    try {
      setLoading(true);
      // const token = await executeRecaptcha("register");
      setvalidmessage((state) => ({
        ...state,
        success: "",
        error: "",
      }));
      let data = { ...signupdata, captcha: "" };
      if (data?.notus) {
        delete data.notus;
      }
      delete data.confirmpassword;
      const formData = new FormData();
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }
      let postdata = formData;
      let res = await callApi(postdata, `api/register`, "POST");
      if (res?.data?.success) {
        // navigate(`${base_url}login`);
        setPasswordStrength("");
        setSignupdata({
          name: "",
          email: "",
          confirmpassword: "",
          password: "",
          referral_code: "",
        });
        setvalidmessage((state) => ({
          ...state,
          success: res?.data?.message,
        }));
        localStorage.setItem("token", res?.data?.token);
        localStorage.setItem("lid", "");
        navigate(`${base_url}userdashboard`, {
          state: { from: "real_account" },
        });
      } else {
        const apiMessage = res?.data?.message;

        const isSqlError =
          apiMessage?.toLowerCase().includes("sql") ||
          apiMessage?.toLowerCase().includes("syntax") ||
          apiMessage?.toLowerCase().includes("query") ||
          apiMessage?.toLowerCase().includes("exception");
        setvalidmessage((state) => ({
          ...state,
          error: isSqlError
            ? t("Somthing Went wrong")
            : apiMessage || t("Somthing Went wrong"),
        }));
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoading(false);
    }
  };
  const videoRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const handleVideoEnd = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
      setIsTransitioning(false);
    }, 100);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleTimeUpdate = () => {
        if (video.duration - video.currentTime <= 1) {
          setIsTransitioning(true);
        }
      };
      video.addEventListener("timeupdate", handleTimeUpdate);
      video.addEventListener("ended", handleVideoEnd);
      video.play();
      return () => {
        video.removeEventListener("timeupdate", handleTimeUpdate);
        video.removeEventListener("ended", handleVideoEnd);
      };
    }
  }, []);
  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setSignupdata((prev) => ({ ...prev, password }));

    const missing = [];

    if (!/[a-z]/.test(password)) missing.push("lowercase");
    if (!/[A-Z]/.test(password)) missing.push("uppercase");
    if (!/\d/.test(password)) missing.push("number");
    if (!/[@$!%*?&#+=\/]/.test(password)) missing.push("special");
    if (password.length < 8) missing.push("8+ characters");

    if (missing.length === 0) {
      setPasswordStrength("Strong");
    } else if (password.length >= 6 && missing.length <= 2) {
      setPasswordStrength("Weak");
    } else {
      setPasswordStrength("Weak");
    }

    setPasswordMissing(missing);
  };
  useEffect(() => {
    if (lid) {
      setSignupdata((state) => ({
        ...state,
        referral_code: lid,
      }));
    }
  }, [lid]);
  const handleToggleCollapse = (id) => {
    const collapseEl = document.getElementById(id);
    if (collapseEl) {
      const bsCollapse = new window.bootstrap.Collapse(collapseEl, {
        toggle: false,
      });
      if (collapseEl.classList.contains("show")) {
        bsCollapse.hide();
        setOpencol(false);
      } else {
        bsCollapse.show();
        setOpencol(true);
      }
    }
  };

  return (
    <div className="theme-color-1">
      <div className="mainLoginbg">
        {/* <video playsInline loop muted autoPlay>
          <source src={bgvideo} type="video/mp4" />
        </video> */}
        <div style={{ position: "relative", overflow: "hidden" }}>
          {/* Video element */}
          <video
            ref={videoRef}
            playsInline
            loop={false}
            muted
            autoPlay
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: !isTransitioning ? 1 : 0,
              transition: "opacity 1s ease-in-out",
            }}
          >
            <source src={bgvideo} type="video/mp4" />
          </video>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "black",
              opacity: isTransitioning ? 1 : 0,
              transition: "opacity 1s ease-in-out",
              pointerEvents: "none",
            }}
          />
        </div>
        <section className="loginRegisterform maxwidth">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-md-8">
                <div className="public-header">
                  <div className="site_logo">
                    <Link to={`${base_url}`}>
                      <img src={logo} alt="" />
                    </Link>
                  </div>
                  <LanguageSwitcher />
                </div>
                <form action="#">
                  <div className="form-title">
                    <h4>{t("Get started in under a minute!")}</h4>
                    <p>
                      {t("Register now and unlock exclusive benefits today.")}
                    </p>
                  </div>
                  {/* <div className="form-group">
                    <input
                      value={signupdata?.name}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(inputValue)) {
                          allsignupdata("name", inputValue);
                        }
                      }}
                      type="text"
                      className={
                        validmessage?.name
                          ? "form-control border-danger"
                          : "form-control"
                      }
                      id="exampleInputname"
                      aria-describedby="name"
                      placeholder={t("Your name")}
                    />
                    {validmessage?.name ? (
                      <p className="p-0 text-danger">{validmessage?.name}</p>
                    ) : (
                      ""
                    )}
                  </div> */}
                  <div className="form-group">
                    <input
                      value={signupdata?.email}
                      onChange={(e) => allsignupdata("email", e.target.value)}
                      type="email"
                      className={
                        validmessage?.email
                          ? "form-control border-danger"
                          : "form-control"
                      }
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder={t("Email address")}
                    />
                    {validmessage?.email ? (
                      <p className="p-0 text-danger">{validmessage?.email}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <input
                          value={signupdata?.password}
                          onChange={handlePasswordChange}
                          type={showpassword?.password ? "text" : "password"}
                          className={`form-control ${
                            passwordStrength === "Weak"
                              ? "border-danger"
                              : passwordStrength === "Medium"
                                ? "border-warning"
                                : passwordStrength === "Strong"
                                  ? "border-success"
                                  : validmessage?.matchpassword ||
                                      validmessage?.password
                                    ? "border-danger"
                                    : ""
                          }`}
                          // className={
                          //   validmessage?.password ||
                          //   validmessage?.matchpassword
                          //     ? "form-control border-danger"
                          //     : "form-control"
                          // }
                          placeholder={t("Password")}
                        />
                        <i
                          onClick={() =>
                            setShowpassword((state) => ({
                              ...state,
                              password: !showpassword?.password,
                            }))
                          }
                          className={`toggle-password fa-regular fa-fw ${
                            showpassword?.password ? "fa-eye" : "fa-eye-slash"
                          }`}
                        ></i>
                        {(passwordStrength || validmessage?.password) && (
                          <small
                            className={`text-${
                              passwordStrength === "Weak"
                                ? "danger"
                                : passwordStrength === "Medium"
                                  ? "warning"
                                  : "success"
                            }`}
                          >
                            {passwordStrength === "Strong"
                              ? t("Strong Password")
                              : `${t(passwordStrength)} ${
                                  passwordMissing.length
                                    ? `(${passwordMissing.join(", ")} missing)`
                                    : ""
                                }`}
                          </small>
                        )}
                        {/* {validmessage?.password ? (
                          <p className="p-0 text-danger">
                            {validmessage?.password}
                          </p>
                        ) : (
                          ""
                        )} */}
                      </div>
                    </div>
                    {/* <div className="col-6">
                      <div className="form-group">
                        <input
                          value={signupdata?.confirmpassword}
                          onChange={(e) =>
                            allsignupdata("confirmpassword", e.target.value)
                          }
                          type={
                            showpassword?.confirmpassword ? "text" : "password"
                          }
                          className={
                            validmessage?.confirmpassword ||
                            validmessage?.matchpassword
                              ? "form-control border-danger"
                              : "form-control"
                          }
                          placeholder={t("Confirm Password")}
                        />
                        <i
                          onClick={() =>
                            setShowpassword((state) => ({
                              ...state,
                              confirmpassword: !showpassword?.confirmpassword,
                            }))
                          }
                          className={`toggle-password fa-regular fa-fw ${
                            showpassword?.confirmpassword
                              ? "fa-eye"
                              : "fa-eye-slash"
                          }`}
                        ></i>
                        {validmessage?.confirmpassword ||
                        validmessage?.matchpassword ? (
                          <p className="p-0 text-danger">
                            {validmessage?.confirmpassword
                              ? validmessage?.confirmpassword
                              : validmessage?.matchpassword}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div> */}

                    <div class="partnerCollapseDiv mb-3">
                      <a
                        class="partnerCollapse"
                        data-bs-toggle="collapse"
                        // href="#partnerCollapseExample"
                        role="button"
                        aria-expanded={opencol}
                        aria-controls="partnerCollapseExample"
                        onClick={() => {
                          handleToggleCollapse("partnerCollapseExample");
                        }}
                      >
                        {t("Partner code")} ({t("optional")})
                        <i
                          style={{ paddingLeft: "5px" }}
                          className={`fa-solid ${
                            opencol ? "fa-angle-up" : "fa-angle-down"
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleCollapse("partnerCollapseExample"); // prevent bubbling to parent link
                            setOpencol(!opencol);
                          }}
                        ></i>
                      </a>
                      <div class={`collapse`} id="partnerCollapseExample">
                        <div class="card card-body p-0 pt-3">
                          <div class="form-group mb-0">
                            <input
                              value={signupdata?.referral_code}
                              onChange={(e) =>
                                allsignupdata("referral_code", e.target.value)
                              }
                              type="text"
                              class="form-control"
                              placeholder="Partner code"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-check mb-3 signcheckbox">
                      <input
                        checked={signupdata?.notus}
                        onChange={(e) =>
                          allsignupdata("notus", e.target.checked)
                        }
                        class="check-input"
                        type="checkbox"
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        {t("I have read and accepted the following agreement")}:{" "}
                        <Link
                          to={`${base_url}termsandconditions`}
                          target="_blank"
                        >
                          {t("Public offer agreement")}
                        </Link>
                        {validmessage?.notus ? (
                          <p className="p-0 text-danger">
                            {t(validmessage?.notus)}
                          </p>
                        ) : (
                          ""
                        )}
                      </label>

                      {/* <label class="form-check-label" for="flexCheckDefault">
                        I declare and confirm that I am not a citizen or
                        resident of the US for tax purposes.
                        {validmessage?.notus ? (
                          <p className="p-0 text-danger">
                            {validmessage?.notus}
                          </p>
                        ) : (
                          ""
                        )}
                      </label> */}
                    </div>
                    {/* <div className="mb-3 d-flex justify-content-center align-items-center flex-column">
                      <ReCAPTCHA
                        sitekey="6LfzgkAsAAAAAGyKPkIdMwB_GqGofI81mW9b7f7K"
                        onChange={handleCaptchaChange}
                        theme="dark"
                      />
                      {validmessage?.robot ? (
                        <p className="p-0 text-danger">{validmessage?.robot}</p>
                      ) : (
                        ""
                      )}
                    </div> */}
                  </div>
                  {validmessage?.error ? (
                    <p className="p-0 text-danger">{t(validmessage?.error)}</p>
                  ) : (
                    ""
                  )}
                  {validmessage?.success ? (
                    <p className="p-0 text-success">{validmessage?.success}</p>
                  ) : (
                    ""
                  )}
                  {loading ? (
                    <button type="button" className="btn bg_btn">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          {t("Loading...")}
                        </span>
                      </div>{" "}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn bg_btn"
                      onClick={() => signupvalidction(signupdata)}
                    >
                      {t("Sign up")}
                    </button>
                  )}

                  <p>
                    {t("Already have an account?")}{" "}
                    <Link to={`${base_url}login`}>{t("Log in")}</Link>
                  </p>
                  <div className="borderline"></div>
                  <div className="or">{t("Or")}</div>

                  <div className="social_icon">
                    {/* <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        handleFacebookLogin();
                      }}
                    >
                      <img src={facebook} alt="" /> {t("Facebook")}
                    </Link> */}
                    <div
                      className="social_logins0"
                      onClick={handleImageClick} // Trigger login on image click
                      style={{ cursor: "pointer" }}
                    >
                      <GoogleOAuthProvider clientId="1097535902152-f8agb9eee4shcjt8td1rtn6rtpel3lpk.apps.googleusercontent.com">
                        <img src={google} alt="" /> {t("Google")}
                        <div className="googleClick">
                          <GoogleLogin
                            ref={googleLoginRef} // Assign ref to GoogleLogin
                            onSuccess={handleLoginSuccess}
                            onError={handleLoginFailure}
                            style={{ display: "none" }} // Hide the default button
                          />
                        </div>
                      </GoogleOAuthProvider>
                    </div>
                    {/* <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        twitterlogin();
                      }}
                    >
                      <img src={twitterfill} alt="" /> {t("Twitter")}
                    </Link> */}
                    {/* <a href="javascript:;"><img src="images/app.svg"></a>  */}
                  </div>
                </form>
              </div>
              {/*  <div className="col-xl-6 col-md-6">
                     <div className="loginCard">
                        <img src="images/signup-bg.png">
                        <div className="shorttext">
                           <h4>Enjoy a $500 Welcome Gift when you sign up!</h4>
                           <p>New to Equlix? Make your first deposit and start trading to claim up to $500!</p>
                           <p>*T&C apply.</p>
                        </div>
                     </div>
                  </div>  */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Signup;
